import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  header: {
    leftLogo: {
      isVisible: true,
      imgSrc: 'https://dev-cdmis-v2-api.ideabreed.net/media/logo_yK4Fnhd.png'
    },
    supTitle: {
      isVisible: true,
      text: 'नेपाल सरकार',
      color: '#ff0000',
      fontSize: 26,
      alignment: 'center'
    },
    title: {
      isVisible: true,
      text: 'सङ्‍घीय मामिला तथा सामान्य प्रशासन मन्त्रालय',
      color: '#ff0000',
      fontSize: 32,
      alignment: 'center'
    },
    subTitle: {
      isVisible: true,
      text: 'सिंहदरबार, काठमाडौँ',
      color: '#ff0000',
      fontSize: 24,
      alignment: 'center'
    },
    rightLogo: {
      isVisible: false,
      imgSrc: null
    }
  },
  subject: {
    isVisible: true,
    text: 'प्रमाण-पत्र',
    color: '#ff0000',
    fontSize: 28,
    alignment: 'left'
  },
  content: {
    isVisible: true,
    text: 'सङ्घीय मामिला तथा सामान्य प्रशासन मन्त्रालयको आयोजनामा मिति [[event_start_date]] गते देखि  [[event_end_date]] सम्म [[event_location]]मा सञ्चालन भएको स्थानीय तह संस्थागत क्षमता स्व-मूल्याङ्कन मुख्य प्रशिक्षक प्रशिक्षणमा  सक्रियतापूर्वक सहभागी हुनुभएका तपाईं सङ्घीय मामिला तथा सामान्य प्रशासन मन्त्रालयका उपसचिव श्री महेन्द्र कुमार सापकोटा लाई सधन्यवाद यो प्रमाणपत्र प्रदान गरिएको छ ।',
    color: '#0000ff',
    fontSize: 24,
    alignment: 'center'
  },
  lowerContent: {
    lowerContentList: [
      {
        isVisible: true,
        imgSrc: 'https://dev-cdmis-v2-api.ideabreed.net/media/logo_yK4Fnhd.png'
      },
      {
        isVisible: true,
        name: 'डा. गोपीकृष्ण खनाल',
        post: 'सहसचिव'
      },
      {
        isVisible: true,
        name: 'एकनारायण अर्याल',
        post: 'सचिव सङ्‍घीय मामिला तथा सामान्य प्रशासन मन्त्रालय'
      }
    ]
  },

  footer: {}
};

export const certificateSlice = createSlice({
  name: 'certificate',
  initialState,
  reducers: {
    setCertificate: (state, action) => {
      state.header = action.payload.header;
      state.subject = action.payload.subject;
      state.content = action.payload.content;
      state.lowerContent = action.payload.lowerContent;
    },
    setHeader: (state, action) => {
      state.header = action.payload;
    },

    setSubject: (state, action) => {
      state.subject = action.payload;
    },

    setContent: (state, action) => {
      state.content = action.payload;
    },

    setLowerContentList: (state, action) => {
      const tempLowerContentList = [...state.lowerContent.lowerContentList];
      tempLowerContentList[action.payload.index] = action.payload.data;

      state.lowerContent = {
        ...state.lowerContent,
        lowerContentList: tempLowerContentList
      };
    },

    addLowerContentItem: (state) => {
      let tempLowerContentList = [...state.lowerContent.lowerContentList];
      tempLowerContentList.push({
        isVisible: true
      });
      state.lowerContent = {
        ...state.lowerContent,
        lowerContentList: tempLowerContentList
      };
    },

    removeLowerContentItem: (state, action) => {
      let tempLowerContentList = [...state.lowerContent.lowerContentList];
      tempLowerContentList = tempLowerContentList.filter((_, index) => index !== action.payload);

      state.lowerContent = {
        ...state.lowerContent,
        lowerContentList: tempLowerContentList
      };
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setHeader,
  setCertificate,
  setSubject,
  setContent,
  setLowerContentList,
  addLowerContentItem,
  removeLowerContentItem
} = certificateSlice.actions;

export default certificateSlice.reducer;
